import { isValidBounds } from "@/providers/maps/utils/is-valid-bounds";

export type DistrictBbox = [number, number, number, number];

export function toOptionalDistrictBbox(
  bounds: number[] | null | undefined,
): DistrictBbox | undefined {
  if (!bounds) {
    return undefined;
  }
  const tuple = bounds as DistrictBbox;

  return isValidBounds(tuple) ? tuple : undefined;
}
